import Vue from 'vue'

export default {
  methods: {
    getValueDefault (obj, key, defaultVal) {
      if (obj === null || obj === undefined) {
        return defaultVal
      }
      if (obj[key] === null || obj[key] === undefined) {
        Vue.set(obj, key, defaultVal)
        return defaultVal
      }
      return obj[key]
    },
    getValue (obj, key) {
      if (obj == null) {
        return null
      }
      return obj[key]
    },
    setValue (obj, key, newValue) {
      if (obj == null) {
        return false
      }
      if (Array.isArray(obj)) {
        this.access = {}
      }
      Vue.set(obj, key, newValue)
    },
  },
}
